import * as React from 'react';
import * as moment from 'moment';
import CollapsibleCard from '../../../common/CollapsibleCard';
import FormDatePicker from '../../../common/form/DatePicker';
import { momentDateFormat } from '../../../../utilities/formatting';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../utilities/identity';

interface Props {
    cancellationDate?: string;
    update: (newCancellationDate?: string) => void;
}

const PropertyCancellationDateSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="Property Cancellation Date"
        cardOpen={!!props.cancellationDate}
        onCardOpenChange={open =>{
            if (isUser)  return;
             props.update(open ? moment().format() : undefined)}}
    >
        <div>
            {props.cancellationDate && (
                <>
                    <FormDatePicker
                        inputProps={{
                            id: 'property-cancellation-date',
                            name: 'propertyCancellationDate',
                            value:
                                props.cancellationDate === undefined
                                    ? moment().format(momentDateFormat)
                                    : moment(props.cancellationDate).format(momentDateFormat),
                            required: true,
                            disabled: isUser
                        }}
                        labelProps={{
                            labelText: 'Property Cancellation Date',
                            invalidText: 'Please select a valid date'
                        }}
                        onChange={(_name, value) => props.update(value)}
                    />
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default PropertyCancellationDateSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/PropertyCancellationDateSection.tsx